import React from "react";

const PersonalInformationProtectionPolicySection = (props) => {
  return (
    <div className="personal-information-protection-policy-container">
      <div className="title">個人情報保護方針</div>
      <div className="text">
        野村ホールディングス株式会社およびその役員・社員等は、関係諸法令および監督当局などのガイドラインを遵守し、以下の基本方針を定めます。
        <br />
        <br />
        1.個人番号を含む個人情報（以下「個人情報等」といいます。）は、法令に則って取得し、その内容は、正確・最新となるよう努めます。
        <br />
        2.個人情報等の利用は、利用目的の範囲を超えては行いません。特に個人番号については、法令で定められた範囲内でのみ取り扱います。また、第三者への個人情報の開示・提供は、法令に基づきその開示が義務づけられるなどの正当な理由がない限り、本人の承諾なしに行いません。
        <br />
        3.個人情報等の流出、不正利用などを防止するために、役員・社員等への教育を徹底します。また、管理・点検の責任者を任命し、適正な管理体制を整備します。
        <br />
        4.個人情報等を外部委託先に取扱わせる場合には、その委託先においても個人情報保護が図られているかについて、責任をもって監督します。
        <br />
        5.個人情報等については、本人の求めにより、開示、訂正、利用停止などを法令に則り、行います。この場合、所定の費用を頂戴することがあります。
        <br />
        <br />
        なお、個人情報等の利用目的など、個人情報に関するお問い合わせは、個人情報相談窓口（〒103-8645東京都中央区日本橋1-13-1野村ホールディングス株式会社グループ総務部、電話：03-5255-1000）にご連絡ください。また、個人情報保護に関する管理態勢等のプログラムは適宜見直し継続的な改善に取り組んでまいります。
      </div>
      <div className="subhead">個人情報の利用目的</div>
      <div className="text">
        1.会社法に基づく権利の行使・義務の履行のため
        <br />
        2.野村グループ報告書の送付など株主に対する情報・サービスの提供を実施するため
        <br />
        3.当社が広報・IR活動などを行う上で必要となる統計データなどを収集するため
        <br />
        4.野村グループの経営管理・内部管理を行うため
        <br />
        5.前各号の個人情報の利用目的にかかわらず、個人番号は「法定書類の作成・提供事務」に限り利用いたします。
      </div>
      <div className="subhead">個人データの共同利用</div>
      <div className="text">
        当社は、以下のとおり、個人データを共同して利用させていただくことがあります。
        <br />
        なお、金融商品取引法その他の法令等で共同利用が制限されている場合は、お客様から同意書を取得した場合等、法令等で認められた場合を除き、共同利用は行いません。
        <br />
        <br />
        1.共同して利用する個人データの項目
        <br />
        ・お名前、ご住所、生年月日、お電話番号、職業、お取引のニーズ等のお客様に関する情報
        <br />
        ・お取引内容、お預かり残高等のお客様の取引に関する情報
        <br />
        2.共同して利用する者の範囲
        <br />
        ・当社及び当社の有価証券報告書等に記載する連結子会社
        <br />
        3.利用目的
        <br />
        ・野村グループとしての総合的なサービスを開発、案内、提供するため
        <br />
        ・野村グループの統合的なコンプライアンス、リスクの管理等の経営管理・内部管理を行うため
        <br />
        4.当該個人データの管理について責任を有する者
        <br />
        ・野村ホールディングス株式会社
      </div>
    </div>
  );
};

export default PersonalInformationProtectionPolicySection;
